





































































































import { Component, Vue } from "vue-property-decorator";
import { translate } from "@/utils";
import { PointModule } from "@/store/point.module";
import { AccountingPoint } from "~/AccountingPoint.type";
import { AccountingPointsModule } from "@/store/accountingpoints.module";
import PointMeterView from "@/components/point/PointMeterView.vue";
import PointSealsView from "@/components/point/PointSealsView.vue";
import PointTransView from "@/components/point/PointTransView.vue";
@Component({
  components: { PointMeterView, PointSealsView, PointTransView },
})
export default class PointsView extends Vue {
  get isLoading() {
    return PointModule.loading;
  }

  get aPoint(): AccountingPoint {
    return translate(PointModule.aPoint);
  }

  async mounted() {
    const point = AccountingPointsModule.pointList.find(
      c => c.account_point_rid.toString() === this.$route.params.pointId,
    );
    if (!point) {
      return this.$router.push({
        name: "accounting-points",
      });
    }

    PointModule.selectPoint(parseInt(this.$route.params.pointId));
  }
}
